document.addEventListener("DOMContentLoaded", () => {


    const productGridContainer = document.querySelector("#ProductGridContainer");
    if (!productGridContainer) return;




    function setActiveSwatch(productCard, colorSwatch) {
        productCard.querySelectorAll(".color-swatch-box").forEach(swatch => {
            swatch.classList.remove("swatch-clicked", "active-swatch");
        });

        colorSwatch.classList.add("swatch-clicked", "active-swatch");





        const variantUrl = colorSwatch.getAttribute("data-variant-url");
        const productLink = productCard.querySelector(".full-unstyled-link");

        if (variantUrl) {
            productLink.setAttribute("href", variantUrl);
        }
        console.log(variantUrl);





        const variantImage = colorSwatch.getAttribute("data-product-img-color");
        const variantImages = productCard.querySelectorAll(".product-variant-image");

        if (variantImage) {
            variantImages.forEach(image => {
                const isMatch = image.getAttribute("data-variant-image") === variantImage;
                image.style.opacity = isMatch ? 1 : 0;
                image.style.zIndex = isMatch ? 4 : 0;
            });

            const initialImage = productCard.querySelector(".initialImage");
            if (initialImage) initialImage.style.display = "none";
        }
        // console.log("1");
    }













    // Handle mouse hover for desktop users
    productGridContainer.addEventListener("mouseover", (event) => {
        if ("ontouchstart" in window) return; // Skip hover effects on touch devices

        const productCard = event.target.closest(".grid__item");
        if (!productCard) return;

        const colorSwatch = event.target.closest(".color-swatch-box");
        if (!colorSwatch) return;

        setActiveSwatch(productCard, colorSwatch);
        console.log("2");
        
    });




    // Restore last clicked swatch image when mouse leaves the product
    productGridContainer.addEventListener("mouseout", (event) => {
        if ("ontouchstart" in window) return; // Skip for touch devices

        const productCard = event.target.closest(".grid__item");
        if (!productCard) return;

        const activeSwatch = productCard.querySelector(".swatch-clicked");
        if (!activeSwatch) return;

        setActiveSwatch(productCard, activeSwatch);
        console.log("3");
    });




    // Handle click event for both desktop and touch devices
    productGridContainer.addEventListener("click", (event) => {
        const productCard = event.target.closest(".grid__item");
        if (!productCard) return;

        const colorSwatch = event.target.closest(".color-swatch-box");
        if (!colorSwatch) return;

        setActiveSwatch(productCard, colorSwatch);
        console.log("4");
    });





    // Handle touch events on mobile to prevent double tap issue
    productGridContainer.addEventListener("touchstart", (event) => {
        const productCard = event.target.closest(".grid__item");
        if (!productCard) return;

        const colorSwatch = event.target.closest(".color-swatch-box");
        if (!colorSwatch) return;

        setActiveSwatch(productCard, colorSwatch);
        console.log("5");
    });


});
